import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalService } from 'ModalService';
import $ from 'jquery';
import { AjaxService } from 'AjaxService';
import { AuthService } from 'AuthService';
import { Router } from '@angular/router';
import { SpinnerService } from '@services/spinner.service';
import { DxFormComponent } from 'devextreme-angular/ui/form';

interface IFeedBackViewModel {
  userName: string;
  email: string;
  betreff: string;
  beschreibung: string;
  route: string;
  error: string;
  browserName: string;
  browserVersion: string;
}

@Component({
  selector: 'app-feedback-modal',
  templateUrl: 'modal-feedback.component.html',
  styleUrls: ['modal-feedback.component.css'],
  standalone: false,
})
export class ModalFeedbackComponent implements OnInit, OnDestroy {
  @Input() id: string;
  isErrorFeedback: boolean = false;
  fb: IFeedBackViewModel = {} as IFeedBackViewModel;
  errMsg: string;
  loading = false;
  @ViewChild('feedBForm', { static: false }) feedBForm: DxFormComponent;
  private element: JQuery<HTMLElement>;

  constructor(
    private authService: AuthService,
    private router: Router,
    private ajaxService: AjaxService,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
    el: ElementRef,
    private _sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    this.element = $(el.nativeElement);
  }

  ngOnInit(): void {
    const modal = this;

    // ensure id attribute exists
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    // move element to bottom of page (just before </body>) so it can be displayed above everything else
    this.element.appendTo('body');

    // close modal on background click
    this.element.on('click', (e: any) => {
      const target = $(e.target);
      if (!target.closest('.app-modal-body').length) {
        modal.close();
      }
    });

    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);
  }

  // remove self from modal service when directive is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  // open modal
  open(error: any): void {
    this.fb.email = this.authService.getUserEMail();
    this.fb.betreff = '';
    this.fb.beschreibung = '';

    const er = error as Error;

    this.fb.error = JSON.stringify(er, null, '\t');
    if (error) {
      this.isErrorFeedback = true;
      this.fb.betreff = er.name + ': ' + er.message;
    }

    this.element.show();

    this.cdr.detectChanges();

    $('body').addClass('modal-open');
  }

  // close modal
  close(): void {
    this.element.hide();
    $('body').removeClass('modal-open');
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }

  sanitizeHtml(html): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  onClickSend() {
    const validationResult = this.feedBForm.instance.validate();
    if (!validationResult.isValid) {
      this.errMsg = '';
      for (const err of validationResult.brokenRules) {
        this.errMsg += err.message + '<br/>';
      }
    } else {
      this.startLoading();
      this.fb.browserName = this.detectBrowserName();
      this.fb.browserVersion = this.detectBrowserVersion();
      this.fb.route = this.router.url;
      this.fb.userName = this.authService.getUserName();
      this.ajaxService
        .post('api/Email/SendFeedbackEmail', this.fb)
        .subscribe(() => {
          this.stopLoading();
          this.closeModal('modal-feedback');
        });
    }
  }

  private startLoading() {
    this.spinnerService.show();
    this.loading = true;
  }

  private stopLoading() {
    this.spinnerService.hide();
    this.loading = false;
  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edg') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(window as any).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(window as any).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }


  detectBrowserVersion(): string {
    const userAgent = navigator.userAgent;
    let tem: RegExpMatchArray | null;
    const match: RegExpMatchArray | null = userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    );

    if (!match) return 'Unknown';

    if (/trident/i.test(match[1])) {
      tem = userAgent.match(/\brv[ :]+(\d+)/g);
      return 'IE ' + (tem?.[1] || '');
    }

    if (match[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem)
        return tem
          .slice(1)
          .join(' ')
          .replace('OPR', 'Opera')
          .replace('Edg', 'Edge');
    }

    const name = match[1];
    let version = match[2];

    tem = userAgent.match(/version\/(\d+)/i);
    if (tem) version = tem[1];

    return `${name} ${version}`;
  }
}
